var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width: " + _vm.intNodeWidth + "px;")),attrs:{"id":"intNodeDiv"}},[_c('svg',{attrs:{"id":"intNode","width":_vm.intNodeWidth,"height":_vm.matrixHeight,"viewbox":("0 0 " + _vm.intNodeWidth + " " + _vm.matrixHeight)}})])}
var staticRenderFns = []

export { render, staticRenderFns }